import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const USER_TYPES = [
  { label: "Driver", value: "Driver" },
  { label: "Admin", value: "Admin" },
  { label: "Individual", value: "Individual" },
];

const USER_STATUS = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];

const EditUserDrawer = ({ isOpen, onClose, user, onUpdateUser }) => {
  const [formData, setFormData] = useState({});
  const { loading } = useSelector((state) => state.users);

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || "",
        email: user.email || "",
        phone_number: user.phone_number || "",
        user_type: user.user_type || "",
        first_name: user.first_name || "",
        middle_name: user.middle_name || "",
        last_name: user.last_name || "",
        postal_address: user.postal_address || "",
        physical_address: user.physical_address || "",
        district: user.district || "",
        village: user.village || "",
        id_or_passport_number: user.id_or_passport_number || "",
        status: user.status || "Active",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const payload = {
      ...formData,
    };

    onUpdateUser({ ...payload, user_id: user.user_id });
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit User</h2>}
      bodyContent={
        <Stack spacing={4}>

          <ReusableInput label="Username" name="username" value={formData.username} onChange={handleChange} />

          <ReusableInput label="First Name" name="first_name" value={formData.first_name} onChange={handleChange} />

          <ReusableInput label="Middle Name" name="middle_name" value={formData.middle_name} onChange={handleChange} />

          <ReusableInput label="Last Name" name="last_name" value={formData.last_name} onChange={handleChange} />

          <ReusableInput label="Email" name="email" value={formData.email} onChange={handleChange} />

          <ReusableInput label="Phone Number" name="phone_number" value={formData.phone_number} onChange={handleChange} />

          <ReusableInput
            label="User Type"
            name="user_type"
            type="select"
            value={formData.user_type}
            options={USER_TYPES}
            onChange={handleChange}
          />

          <ReusableInput label="Postal Address" name="postal_address" value={formData.postal_address} onChange={handleChange} />

          <ReusableInput label="Physical Address" name="physical_address" value={formData.physical_address} onChange={handleChange} />

          <ReusableInput label="District" name="district" value={formData.district} onChange={handleChange} />

          <ReusableInput label="Village" name="village" value={formData.village} onChange={handleChange} />

          <ReusableInput label="ID / Passport" name="id_or_passport_number" value={formData.id_or_passport_number} onChange={handleChange} />

          <ReusableInput
            label="Status"
            name="status"
            type="select"
            value={formData.status}
            options={USER_STATUS}
            onChange={handleChange}
          />

        </Stack>
      }
      footerContent={
        <Stack direction="row" justify="flex-end">
          <GradientButton onClick={onClose}>
            Cancel
          </GradientButton>

          <GradientButton onClick={handleSubmit} loading={loading}>
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditUserDrawer;